import { useSetAtom } from 'jotai';
import { Button, Tooltip } from '@optiaxiom/react';

import { opalOverlayOpenAtom } from '@frontend/atoms';

export function OpalOverlayButton() {
  const setIsOpen = useSetAtom(opalOverlayOpenAtom);

  return (
    <Tooltip content="Open Opal Chat" delayDuration={0}>
      <Button
        appearance="default-opal"
        aria-label="Open Opal Chat"
        onClick={() => setIsOpen(v => !v)}
        z="10"
      >
        Ask Opal
      </Button>
    </Tooltip>
  );
}
